import { render } from "./AddParcel.vue?vue&type=template&id=092f71eb&scoped=true"
import script from "./AddParcel.vue?vue&type=script&lang=js"
export * from "./AddParcel.vue?vue&type=script&lang=js"

import "./AddParcel.vue?vue&type=style&index=0&id=092f71eb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-092f71eb"]])

export default __exports__